var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWasteToEnergyIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.425,
    height: 44.425,
    viewBox: "0 0 44.425 44.425",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-waste-to-energy-3308013",
    transform: "translate(-16 -16.347)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(21.425 56.347)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9609",
    "data-name": "Path 9609",
    d: "M18.239,232.207v4.477a.746.746,0,0,0,.149.448l2.089,2.786v2.3a3.73,3.73,0,0,0,1.492,7.15h9.7a.746.746,0,0,0,.746-.746V230.715h2.239v-1.492H32.416v-.746a.746.746,0,0,0-.746-.746H29.432v-1.492a.746.746,0,0,0-.565-.724l-5.97-1.492a.746.746,0,0,0-.821.34l-2.021,3.369H18.239a2.239,2.239,0,1,0,0,4.477Zm1.492,13.432a2.239,2.239,0,1,1,2.239,2.239,2.239,2.239,0,0,1-2.239-2.239Zm5.221,2.239a3.729,3.729,0,0,0-2.983-5.97v-2.239a.746.746,0,0,0-.149-.448l-2.089-2.786v-4.228h6.407l1.274,1.274a.746.746,0,0,0,.528.219h2.985v14.178ZM23.071,225.6l4.868,1.217v.91H21.8Zm-4.833,3.619H30.924v2.985H28.248l-1.274-1.274a.746.746,0,0,0-.528-.219H18.239a.746.746,0,1,1,0-1.492Z",
    transform: "translate(0 -188.598)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3844",
    "data-name": "Rectangle 3844",
    width: 1,
    height: 2,
    transform: "translate(42.425 16.347)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3845",
    "data-name": "Rectangle 3845",
    width: 1.492,
    height: 2.239,
    transform: "matrix(0.924, -0.383, 0.383, 0.924, 35.32, 17.649)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3846",
    "data-name": "Rectangle 3846",
    width: 1.492,
    height: 2.239,
    transform: "translate(29.672 21.773) rotate(-45)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3847",
    "data-name": "Rectangle 3847",
    width: 1.492,
    height: 2.239,
    transform: "translate(26.032 27.745) rotate(-67.5)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3848",
    "data-name": "Rectangle 3848",
    width: 3,
    height: 1,
    transform: "translate(24.425 33.347)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3849",
    "data-name": "Rectangle 3849",
    width: 1.492,
    height: 2.239,
    transform: "translate(53.416 45.517) rotate(-45)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3850",
    "data-name": "Rectangle 3850",
    width: 1.492,
    height: 2.239,
    transform: "matrix(0.383, -0.924, 0.924, 0.383, 57.055, 40.595)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3851",
    "data-name": "Rectangle 3851",
    width: 2,
    height: 1,
    transform: "translate(58.425 33.347)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3852",
    "data-name": "Rectangle 3852",
    width: 2.239,
    height: 1.492,
    transform: "translate(57.055 27.223) rotate(-22.5)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3853",
    "data-name": "Rectangle 3853",
    width: 2.239,
    height: 1.492,
    transform: "translate(53.416 22.301) rotate(-45)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3854",
    "data-name": "Rectangle 3854",
    width: 2.239,
    height: 1.492,
    transform: "translate(48.17 19.146) rotate(-67.5)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9610",
    "data-name": "Path 9610",
    d: "M232.746,171.193H232v1.492h.746a6.723,6.723,0,0,0,6.716-6.716v-3.422l1.711,1.711,1.055-1.055-2.985-2.985a.746.746,0,0,0-1.055,0L235.2,163.2l1.055,1.055,1.711-1.711v3.422A5.229,5.229,0,0,1,232.746,171.193Z",
    transform: "translate(-195.853 -130.569)",
    fill: "#253845"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9611",
    "data-name": "Path 9611",
    d: "M166.177,56h0A14.165,14.165,0,0,0,152,70.113c0,.283.006.57.021.851l1.49-.082c-.014-.252-.02-.509-.019-.763A12.685,12.685,0,1,1,173.408,80.6a8.187,8.187,0,0,0-3.466,5.993h-7.53a8.316,8.316,0,0,0-3.515-6.027c-.236-.166-.469-.341-.693-.522l-.939,1.16c.25.2.51.4.774.583a6.8,6.8,0,0,1,2.914,5.552v5.97a.742.742,0,0,0,.079.333h0l1.492,2.985a.746.746,0,0,0,.667.412h5.97a.746.746,0,0,0,.667-.412l1.492-2.985h0a.742.742,0,0,0,.079-.333V87.34a6.706,6.706,0,0,1,2.859-5.514A14.178,14.178,0,0,0,166.177,56Zm3.731,33.787-7.462,2.487V90.863l7.462-2.487Zm0,1.573v1.2H166.3Zm-3.852-3.274-3.61,1.2v-1.2Zm2.645,7.462h-5.047l-.746-1.492h6.54Z",
    transform: "translate(-123.314 -36.269)",
    fill: "#253845"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWasteToEnergyIconBlack);
export default __webpack_public_path__ + "static/media/waste-to-energy-icon-black.48ae7ffcd1bd50a29c57d8a3a6fb9590.svg";
export { ForwardRef as ReactComponent };